module.exports = __webpack_public_path__ + "static/media/icon-checkbox-on-alt.200cde60.svg";